export default {
  async referralWallet(userId, config = {}) {
    return await this.$get({
      url: `${this.$baseurl}/admin/personal/users/${userId}/referral-wallet`,
      headers: this.headers,
      ...config,
    });
  },
};
